<div class="not-found-page__fill-frame">
  <h2>404: Deze pagina kan niet gevonden worden</h2>
  <app-button mode="secondary" type="button" routerLink="/">Ga terug naar home</app-button>
</div>
